import React from 'react'

function Footer() {
    return (
        <>
            <footer className="main-footer footer-main">
                <strong>
                    Copyright &copy; 2022
                    <a href="https://codecanyon.net/user/soft-miner"> Soft-Miner</a>.
                </strong>
                &nbsp;All rights reserved.
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> 1.0.0
                </div>
            </footer>

            <aside className="control-sidebar control-sidebar-dark">
            </aside>
        </>
    )
}

export default Footer
